export default __webpack_public_path__ + "static/media/chimeron-hero.76e30675.mp4";